import IconBack from "../../../audi-ui-components/icons/Back";
import Map from "./Map";

const Frame = ({ locations, activeTab, onClick = ()=>{}, onBackClick, backButtonText, children }) => {

    const getMarkers = () => {
        if (!locations) return [];
        let icon = "default";
        let firstIcon = "default";
        if (locations.length > 20) {
            icon = "circle";
            firstIcon = "circle";
        } else if (locations.length > 1) {
            icon = "small";
            firstIcon = "medium";
        }
        var m = [];
        for (let i=0; i<locations.length; i++) {
            let loc = locations[i];
            if (!activeTab || activeTab === loc.type) {
                m.push({
                    lat: parseFloat(loc.latitude),
                    lng: parseFloat(loc.longitude),
                    icon: i === 0 ? firstIcon : icon,
                    onClick: () => { onClick(loc); }
                });
            }
        }
        return m;
    }

    const markers = getMarkers();
    return (
        <div className="container-fluid">
            
            <div className="locate-frame">
                <div className="map-wrapper">
                    <Map markers={markers} animateMarkers={markers.length <= 2} showBlurState apiKey={process.env.RAZZLE_GOOGLE_MAPS_API_KEY} />
                </div>
                <div className="locate-frame__content">
                    <div className="locate-frame__back px-4">
                        {backButtonText && <button className="aui-button" onClick={onBackClick}><IconBack small /> {backButtonText}</button>}
                    </div>
                    {children}
                </div>
            </div>
        </div>
    );
}

export default Frame;
